module.exports = __webpack_public_path__ + "img/844a53f7f4abee06934129083c760833.png";